// extracted by mini-css-extract-plugin
export default {"l_MovePageButtonIcon_main":"MovePageButtonIcon_l_MovePageButtonIcon_main__CQPq8"};